import React from 'react'
import { useSelector } from 'react-redux'

const ItemRule = ({ index, rule }) => {
  const levels = useSelector(
    (state) => state?.analytics?.analyticsCurriculum?.datasets?.curriculum?.levels || []
  )
  if (!levels.find((level) => level._id === null)) {
    levels.unshift({ _id: null, name: 'Not assessed' })
  }
  const status = useSelector(
    (state) => state?.analytics?.analyticsCurriculum?.datasets?.data?.data?.status || []
  )
  return (
    <div className='flex gap-4 items-center justify-start py-2' key={index}>
      <div className='bg-loading rounded-full size-8 flex items-center justify-center text-lg'>
        {index + 1}
      </div>
      <div>
        {rule.description && (
          <div>
            <b className='text-xs uppercase text-primary'>Description: </b>
            <span className='text-sm pl-2'>{rule.description}</span>
          </div>
        )}
        <b className='text-xs uppercase text-primary'>Status: </b>
        <b className='text-xs uppercase text-primary'>UL Status: </b>
        <div className='text-sm pl-2'>
          {status
            ?.filter((s) => rule.statusId?.includes(s._id))
            ?.map((s) => s.name)
            .join(', ')}
        </div>
        <div>
          <b className='text-xs uppercase text-primary'>Conditions</b>
          <div className='text-sm pl-2'>
            {rule.conditions?.map((condition, i) => {
              const lcCondition = condition.condition === 'every' ? 'LC' : 'LCs'
              return (
                <div key={i}>
                  <span>
                    <b className='capitalize'>{condition.condition}</b> {lcCondition} are at{' '}
                  </span>
                  <span>
                    {levels
                      ?.filter((s) => condition.includesLevelId?.includes(s._id))
                      ?.map((s) => s.name)
                      .join(', ')}
                  </span>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ItemRule
